module.exports = __webpack_public_path__ + "img/stp_lct@2x.5e79e2c9.png";